<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { ControlsContainer, Text } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Components
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	import ThermostatTemperatureWheel from 'src/components/XT1/Thermostat/ThermostatTemperatureWheel.svelte';
	import TemplateThermostatMode from './components/TemplateThermostatMode.svelte';
	import TemplateStatuses from './components/TemplateStatuses.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device, statuses: VCInterfaceStatus[];

	const _device = device;
	$: enable = statuses.find((i) => i.role === 'enable');
	$: thermostatMode = statuses.find((i) => i.role === 'thermostat_mode');
	$: fanMode = statuses.find((i) => i.role === 'fan_mode');
</script>

<div class="flex-full-height">
	<TemplateStatuses {statuses} templateRoles={['current_humidity']} />
	<div class="flex-full-height justify-content-end">
		<ThermostatTemperatureWheel {device} {statuses} />
		<TemplateThermostatMode {device} status={thermostatMode} />
		<TemplateThermostatMode {device} status={fanMode} />
		{#if enable}
			<ControlsContainer color={$showNewLayout ? 'color-0' : undefined}>
				<svelte:fragment slot="first">
					<VirtualBooleanButton
						isWide
						device={_device}
						componentID={enable?.id}
						value={enable?.event}
					/>
					<Text styleType="controls-large" class="mt-s text-bold"
						>{capFirstChar(
							enable?.event
								? $format('label_action_turn_off', { default: 'turn off' })
								: $format('label_action_turn_on', { default: 'turn on' }),
						)}</Text
					>
				</svelte:fragment>
			</ControlsContainer>
		{/if}
	</div>
</div>
